import type React from "react"

type Props = {
  title: string
  description: string
  media: React.ReactNode
}


export function FeatureCard({ title, description, media }: Props) {
  return (
    <div className="h-full border rounded-3xl shadow-sm flex flex-col sm:rounded-2xl">
      <div className="p-4 md:p-6 flex flex-col h-full sm:p-3">
        {/* Media area */}
        <div className="flex-shrink-0">
          {media}
        </div>

        {/* Text */}
        <div className="mt-4 flex-grow sm:mt-3">
          <h3 className="text-2xl font-semibold md:text-xl sm:text-lg">{title}</h3>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed sm:text-xs sm:mt-1.5 sm:leading-snug">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}